import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Storyboard} from "storyboard-renderer";
import {Router} from "@angular/router";

@Component({
  selector: 'app-storyboard-item',
  templateUrl: './storyboard-item.component.html',
  styleUrls: ['./storyboard-item.component.scss']
})
export class StoryboardItemComponent implements OnInit {

  @Input() item;
  @Output() deleteStoryboardEvent = new EventEmitter();
  @Output() duplicateStoryboardEvent = new EventEmitter();

  constructor(private router: Router) { }

  ngOnInit() {
  }

  delete() {
    this.deleteStoryboardEvent.next(this.item);
  }

  open(item: Storyboard) {
    if (item.last_video_export && item.last_video_export.convertation.completed == true) {
      this.router.navigate(['/storyboard-publish', item.id]);
    } else {
      this.router.navigate(['/storyboard/', item.id]);
    }
  }

  duplicate() {
    this.duplicateStoryboardEvent.next(this.item);
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/storyboard-item/storyboard-item.component.ts